
import { Box, Typography } from '@mui/material';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';

const DataCard = ({ data, index, activeId, setActiveId, company, groupArray }) => {
    return (
        <Box
            key={index}
            className="biochar-project"
            sx={{
                display: 'flex', flexDirection: 'column',
                ...(activeId === data?.id &&
                {
                    background: 'linear-gradient(to bottom right, #535988, #313551)',
                    color: '#FFF',
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
                })
            }}
            onClick={() => {
                setActiveId(data?.id)
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                <Typography sx={{ fontSize: '18px' }}>{activeId === data?.id ?
                    <BookmarkOutlinedIcon sx={{ verticalAlign: 'bottom' }} /> :
                    <BookmarkBorderOutlinedIcon sx={{ verticalAlign: 'bottom' }} />}
                    {data?.id}
                </Typography>
            </Box>
            <Box>
                <Box>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        Company:
                    </Typography>
                </Box>
                <Box>
                    {company}
                </Box>
            </Box>
            {groupArray?.includes(data?.name) &&
                <Box>
                    <Box>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Group:
                        </Typography>
                    </Box>
                    <Box>
                        {data?.name}
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default DataCard